import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/star/logo.png'
import _imports_1 from '@/assets/star/share-close.png'


const _withScopeId = n => (_pushScopeId("data-v-aea8e426"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "star-dialog star-unlock-dialog" }
const _hoisted_2 = { class: "star-dialog-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "star-dialog-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "star-dialog-logo"
  }),
  /*#__PURE__*/_createTextVNode(" 温馨提示 ")
], -1))
const _hoisted_4 = { class: "star-dialog-body star-unlock-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "star-unlock-text" }, "使用次数已用尽", -1))
const _hoisted_6 = {
  key: 0,
  class: "star-unlock-loading"
}
const _hoisted_7 = {
  key: 1,
  class: "star-unlock-share"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "star-unlock-purchase-expand"
}
const _hoisted_10 = {
  ref: "purchaseQrRef",
  class: "star-unlock-purchase-qr"
}
const _hoisted_11 = {
  key: 3,
  class: "star-unlock-purchase-tip"
}
const _hoisted_12 = { class: "star-promo-dialog" }
const _hoisted_13 = { class: "star-promo-visual" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 2,
  class: "star-dialog-mask"
}
const _hoisted_16 = { class: "star-dialog" }
const _hoisted_17 = { class: "star-dialog-header" }
const _hoisted_18 = { class: "star-dialog-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "star-dialog-logo"
}, null, -1))
const _hoisted_20 = { class: "star-dialog-body" }
const _hoisted_21 = { class: "star-dialog-content" }
const _hoisted_22 = { class: "star-dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.unlock.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "star-dialog-mask",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", {
                class: "star-dialog-close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              (_ctx.unlock.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "加载中..."))
                : (_ctx.unlock.showBanner && _ctx.thumbnailImageUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", {
                        class: "star-unlock-share-inner",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBannerClick && _ctx.onBannerClick(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.thumbnailImageUrl,
                          class: "star-unlock-share-img",
                          alt: ""
                        }, null, 8, _hoisted_8),
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "star-icon-close star-unlock-share-close",
                          alt: "",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onShareClose && _ctx.onShareClose(...args)), ["stop"]))
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "star-unlock-purchase",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPurchaseClick && _ctx.onPurchaseClick(...args)))
              }, "购买使用权益"),
              (_ctx.unlock.showPurchase)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, null, 512)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.unlock.showPurchase)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 打开APP，进入\"九爻股-商城\"购买权益 "))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.unlock.showPromo)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "star-dialog-mask star-promo-mask",
          onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPromoClose && _ctx.onPromoClose(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              src: _imports_1,
              class: "star-icon-close star-promo-close",
              alt: "",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPromoClose && _ctx.onPromoClose(...args)))
            }),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.promoImageUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.promoImageUrl,
                    class: "star-promo-img",
                    alt: ""
                  }, null, 8, _hoisted_14))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.tipDialog.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.tipDialog.title), 1)
              ]),
              _createElementVNode("span", {
                class: "star-dialog-close",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tipDialog.visible = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.tipDialog.content), 1),
              _createElementVNode("div", _hoisted_22, [
                (_ctx.tipDialog.showCancel)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "star-btn-cancel",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.tipDialog.visible = false))
                    }, "取消"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "star-btn-confirm",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.tipDialog.onConfirm && _ctx.tipDialog.onConfirm(...args)))
                }, _toDisplayString(_ctx.tipDialog.confirmText), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}